import React from 'react';

// Native selects stay usable at the viewport edge and support mobile pickers.
const PageSizeSelect = ({ options, currSizePerPage, onSizePerPageChange }) => (
  <label className="page-size-select">
    Rows per page
    <select className="form-control" value={currSizePerPage}
      onChange={event => onSizePerPageChange(Number(event.target.value))}>
      {options.map(option => <option key={option.page} value={option.page}>{option.text}</option>)}
    </select>
  </label>
);

export default PageSizeSelect;
